import { Group, Rect, Text, Image } from 'react-konva';
import React, { useRef } from 'react';
import { useProgressiveImage } from '@shakkerai/pro-hooks';
import { translate } from '@shakkerai/util-i18n';
import { viewportActions } from '@starflow/app/store';
import { getWrappedElement } from '@starflow/app/extension';

export { ImageOverlayer, ImageOverlayerInner } from './Overlayer';

const handleDblClick = (event) => {
  const elementId = event.target.name();
  viewportActions.locateElement(elementId, { animate: true, fitView: true });
};

const IllegalImageElement = (props) => {
  return (
    <>
      <Rect role="element" roleType="image" fill="white" {...props}></Rect>
      <Text
        text={translate('illigal_content_text')}
        fontSize={20}
        align="center"
        fill="black"
        verticalAlign="middle"
        padding={50}
        {...props}
      />
    </>
  );
};

const NormalImageElement = (props) => {
  const { element, viewport, currentElementTool, currentCanvasTool, editingElementId } = props;

  const imageRef = useRef(null);
  const image = useProgressiveImage(element, imageRef, viewport);
  const WrappedImage = getWrappedElement('image', Image);

  return (
    <WrappedImage
      image={image}
      ref={imageRef}
      name={element.id}
      role="element"
      roleType="image"
      id={element.id + '-image'}
      onDblClick={handleDblClick}
      fill={image ? undefined : '#b3dbd830'}
      imageUrl={element.url}
      width={element.width}
      height={element.height}
      data={element.data}
      modifiers={element.modifiers}
      elementId={element.id}
      editingElementId={editingElementId}
      currentCanvasTool={currentCanvasTool}
      currentElementTool={currentElementTool}
    />
  );
};

const EmptyImageElement = () => {
  return (
    <>
      <Rect role="element" roleType="image" fill="white"></Rect>
      <Text text="请选择上一步图片" fontSize={20} align="center" fill="black" verticalAlign="middle" padding={50} />
    </>
  );
};

const ImageElementInner = (props) => {
  const { element } = props;

  // if (element.isEmpty) {
  //   return <EmptyImageElement />;
  // }
  if (element.data?.illegal) {
    return <IllegalImageElement width={element.width} height={element.height} />;
  }
  return <NormalImageElement {...props} />;
};

export const ImageElement = React.memo((props) => {
  return (
    <Group>
      <ImageElementInner {...props} />
    </Group>
  );
});
